import React, { useState, useContext, createContext } from 'react'
import { useLocation } from 'react-router-dom'

export type SearchViewContext = {
    showSearchFilter: boolean
    toggleSearchFilter: (newState: boolean) => void
    showFooter: boolean
    toggleFooter: (newState: boolean) => void
    showSavedSearches: boolean
    setShowSavedSearches: (newState: boolean) => void
    showSaveThisSearch: boolean
    setShowSaveThisSearch: (newState: boolean) => void
}
export const defaultSearchViewContext: SearchViewContext = {
    showSearchFilter: false,
    toggleSearchFilter: () => {},
    showFooter: true,
    toggleFooter: () => {},
    showSavedSearches: false,
    setShowSavedSearches: () => {},
    showSaveThisSearch: false,
    setShowSaveThisSearch: () => {},
}
export const SearchViewStateContext = createContext(defaultSearchViewContext)
export const SearchViewContextProvider: React.FC<React.PropsWithChildren<object>> = ({ children }) => {
    const { search } = useLocation()
    const [showSearchFilter, toggleSearchFilter] = useState<boolean>(false)
    const [showSavedSearches, setShowSavedSearches] = useState<boolean>(search.includes('showSaveSearch=true'))
    const [showSaveThisSearch, setShowSaveThisSearch] = useState<boolean>(false)
    const [showFooter, toggleFooter] = useState<boolean>(true)
    return (
        <SearchViewStateContext.Provider
            value={{
                showSearchFilter,
                toggleSearchFilter,
                showFooter,
                toggleFooter,
                showSavedSearches,
                setShowSavedSearches,
                showSaveThisSearch,
                setShowSaveThisSearch,
            }}
        >
            {children}
        </SearchViewStateContext.Provider>
    )
}
export const useSearchViewState = () => {
    return useContext(SearchViewStateContext)
}
